import React, { Fragment } from 'react';
import ResponsiveModal from '../../../../components/Modal/responsive-modal';
import TenantTerms, { MaximumPolicyCover } from './tenant-terms';
import Button from '../../../../components/Button';

interface TermsModalProps {
  closeTerms: () => void;
  maximumPolicyCover: MaximumPolicyCover;
}

const TermsModal: React.FC<TermsModalProps> = ({ closeTerms, maximumPolicyCover }) => {
  return (
    <ResponsiveModal onDismiss={closeTerms}>
      <Fragment>
        <TenantTerms maximumPolicyCover={maximumPolicyCover} />
        <Button
          style={{ margin: 0, position: 'fixed', bottom: 20, left: '50%', zIndex: 1000, transform: 'translateX(-50%)' }}
          onClick={closeTerms}
        >
          Close
        </Button>
      </Fragment>
    </ResponsiveModal>
  );
};

export default TermsModal;
